import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { Button, Modal, Space, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import { PDFViewer } from '../../components/design/PDFviewer';
import { getFilePath, getPreviewUrl, isShowable } from "../../library/constants";
import style from './received-artwork.module.scss';

const RecievedFiles = ({ image, name, comment, project_id, item_id, itemId }) => {
    const [isModalOpen, setisOpen] = useState(false)
    const effectiveItemId = itemId ?? item_id;
    const getFileExtension = (fileName) => {
        return fileName?.split('.').pop();
    };
    const fileType = getFileExtension(name);
    const handleCancel = () => {
        setisOpen(false);
    };
    return (
        <div className={style.itemDetail}>
            <div className={style.bottomButton}>
                <img src={getPreviewUrl(image, project_id, effectiveItemId)} alt={name} className={style.imageBox} />
                <div className={style.imageName}>
                    <h4>{name}</h4>
                    {comment != undefined && <p><b>Comment</b> : {comment}</p>}
                    <Space.Compact className={style.actionButtons}>
                        <Link reloadDocument to={getFilePath(image, project_id, effectiveItemId)} download="image.png">
                            <Button icon={<DownloadOutlined />}>Download</Button>
                        </Link>
                        <Button icon={<EyeOutlined />} onClick={() => { isShowable(image) ? setisOpen(true) : message.warning('Only PDF files can be viewed') }}>View</Button>
                    </Space.Compact>
                </div>
            </div>
            <Modal open={isModalOpen} onCancel={handleCancel} footer={<Button onClick={() => { setisOpen(false) }} >Close</Button>}>
                <PDFViewer path={image} project_id={project_id} item_id={effectiveItemId} type={fileType} />
            </Modal>
        </div>
    )
}

RecievedFiles.propTypes = {
    image: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    comment: PropTypes.string,
    project_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    item_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    itemId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default RecievedFiles